import { Flex } from "@chakra-ui/react";

import { ConfigureIconButton } from "@/common/components/CommonIconButtons";
import { SectionHeading } from "@/common/components/SectionHeading";
import { SidebarSection } from "@/common/components/SidebarLayout";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import useFeatureIntegrations from "@/feature/hooks/useFeatureIntegrations";
import { LinearTrackingEntityDisplay } from "@/integration/components/linear/LinearTrackingEntityDisplay";
import { SlackChannelDisplay } from "@/integration/components/slack/SlackChannelDisplay";
import { FeatureDetail } from "@reflag/shared/featureAPI";
import { FeatureSettingsUrl } from "@reflag/shared/urls";

type FeatureIntegrationsActionsProps = {
  feature: FeatureDetail;
};

export function FeatureIntegrationsActions({
  feature,
}: FeatureIntegrationsActionsProps) {
  const { slack, linear, isLoading } = useFeatureIntegrations(feature.id);
  const { env, org } = useEnvironment();

  return (
    <>
      {org.integrations.slack && (
        <SidebarSection gap={1}>
          <SectionHeading isLoading={isLoading} variant="subtle">
            Slack
          </SectionHeading>

          {!isLoading && (
            <Flex
              fontSize="sm"
              gap={2}
              justifyContent="space-between"
              width="full"
            >
              <SlackChannelDisplay
                slackChannel={slack?.slackChannel}
                link
                showTooltip
              />
              <ConfigureIconButton
                alignSelf={"end"}
                color={"dimmed"}
                iconSize={16}
                label="Configure Slack integration"
                mr={-2}
                to={FeatureSettingsUrl(env, feature, "slack")}
              />
            </Flex>
          )}
        </SidebarSection>
      )}
      {org.integrations.linear && (
        <SidebarSection gap={1}>
          <SectionHeading isLoading={isLoading} variant="subtle">
            Linear
          </SectionHeading>
          {!isLoading && (
            <Flex
              fontSize="sm"
              gap={2}
              justifyContent="space-between"
              width="full"
            >
              <LinearTrackingEntityDisplay
                entity={linear?.trackingEntity}
                showTypeIcon={false}
                link
                showTooltip
              />
              <ConfigureIconButton
                alignSelf={"end"}
                color={"dimmed"}
                iconSize={16}
                label="Configure Linear integration"
                mr={-2}
                to={FeatureSettingsUrl(env, feature, "linear")}
              />
            </Flex>
          )}
        </SidebarSection>
      )}
    </>
  );
}
